import {backUser} from "../axios";

export const authApi = [
    {url: `${backUser}/auth/logout`, name: 'auth.logout', method: 'POST'},
    {url: `${backUser}/auth/user`, name: 'auth.user', method: 'GET'},
    {url: `${backUser}/auth/refresh`, name: 'auth.refresh', method: 'POST'},
    {url: `${backUser}/auth/forgot-password`, name: 'auth.forgot.password', method: 'POST'},
    {url: `${backUser}/auth/check-code`, name: 'auth.check.code', method: 'POST'},
    {url: `${backUser}/auth/change-password`, name: 'auth.change.password', method: 'POST'},
    {url: `${backUser}/auth/confirmation-email`, name: 'auth.confirmation.email', method: 'GET'},
]